import React from 'react'

const ViewGatePass = () => {
  return (
    <div>ViewGatePass</div>
  )
}

export default ViewGatePass